<template>
<div>
  <div id="contact_form" class="clearfix">
    <img src="../assets/img/contact.jpg" alt="お問い合わせページの画像" class="contactImg">
    <img src="../assets/img/contact_spimg.jpg" alt="お問い合わせページの画像" class="contactSPImg">
    <div class="contact_content clearfix">
      <div class="title clearfix">
        <h2>お問い合わせ</h2>
      </div>
      <form method="POST" id="form" action="https://docs.google.com/forms/d/e/1FAIpQLSdyJqne8LWIueZZCr-9ntld9ErT0Ml_QfWXz4NKwADclYhs1A/formResponse" class="contact_box" target="redirect" @submit="formSubmit">
        <p class="contact_title">{{ this.contactTitle.subject }}</p>
        <select class="minimal" name="entry.2051981835" v-model="subject">
          <option>運営メンバー応募について</option>
          <option>インターン情報掲載について</option>
          <option>広告掲載について</option>
          <option>学生集客について</option>
          <option>業務提携について</option>
          <option>その他</option>
        </select>
        <p class="contact_title">{{ this.contactTitle.company }}</p>
        <label class="contact_color"><input type="text" v-model="companyName" placeholder="(例)〇〇大学" name="entry.1910706083"></label>
        <p class="contact_title clearfix">{{ this.contactTitle.name }}</p>
        <label class="contact_color contact_short"><input type="text" v-model="firstName" placeholder="姓" name="entry.209926591"></label>
        <label class="contact_color contact_short"><input type="text" v-model="lastName" placeholder="名" name="entry.339360867"></label>
        <p class="contact_title clearfix">{{ this.contactTitle.nameKana }}</p>
        <label class="contact_color contact_short"><input type="text" v-model="firstNameKana" placeholder="セイ" name="entry.1121714836"></label>
        <label class="contact_color contact_short"><input type="text" v-model="lastNameKana" placeholder="メイ" name="entry.1611086794"></label>
        <p class="contact_title">{{ this.contactTitle.phone }}</p>
        <label class="contact_color"><input type="tel" v-model="phone" placeholder="(例)050-3245-3432" name="entry.2067646486"></label>
        <p class="contact_title">{{ this.contactTitle.email }}</p>
        <label class="contact_color"><input type="email" v-model="email" placeholder="(例)xxxxxxxx@example.com" name="entry.102151385"></label>
        <p class="contact_title">{{ this.contactTitle.message }}</p>
        <div class="contact_color_box">
          <label class="contact_color_box2"><textarea type="text" v-model="message" placeholder="お問い合わせ内容" name="entry.1993050287"></textarea></label>
          <button type="submit" value="送信する" class="contact_page_btn">送信する</button>
        </div>
      </form>
    </div>
  </div>
  <modal
    name="ack"
    transition="pop-out"
    width="80%"
    minWidth="300px"
    height="580px"
  >
  <!-- 確認用ダイアログここから -->
  <div class="dialog-content">
    <div class="dialog-alert">
      <h2 class="dialog-alert-text">以下の内容で送信しますか？</h2>
    </div>
    <div>
      <dl>
        <dt>{{ this.contactTitle.subject }}</dt>
        <dd>{{ this.subject}}</dd>
        <dt>{{ this.contactTitle.company }}</dt>
        <dd>{{ this.companyName}}</dd>
        <dt>{{ this.contactTitle.name }}</dt>
        <dd>{{ this.firstName }} {{ this.lastName }}</dd>
        <dt>{{ this.contactTitle.nameKana }}</dt>
        <dd>{{ this.firstNameKana }} {{ this.lastNameKana }}</dd>
        <dt>{{ this.contactTitle.phone }}</dt>
        <dd>{{ this.phone }}</dd>
        <dt>{{ this.contactTitle.email }}</dt>
        <dd>{{ this.email }}</dd>
        <dt>{{ this.contactTitle.message }}</dt>
        <dd>{{ this.message }}</dd>
      </dl>
      <button type="button" class="contact_page_btn vue-dialog-button contact_page_btn-l" style="width: 50%; left:0;" @click="sendRequest();hide('ack');replaceView();toTop();">
        送信する
      </button>
      <button type="button" class="contact_page_btn vue-dialog-button" style="width: 50%; right:0" @click="hide('ack');toTop();">
        CLOSE
      </button>
    </div>
  </div>
  </modal>
  <!-- 確認用ダイアログここまで -->

  <!-- 入力エラーダイアログここから -->
  <modal
    name="err"
    transition="pop-out"
    width="80%"
    minWidth="300px"
    height="580px"
  >
  <div class="dialog-content">
    <div class="dialog-alert">
      <h2 class="dialog-alert-text">送信内容が不正な値です</h2>
    </div>
    <div class="vue-dialog-buttons">
      <ul>
      <li v-for="error in errors" v-bind:key="error.id">{{ error }}</li>
    </ul>
      <button type="button" class="contact_page_btn vue-dialog-button" style="flex: 1 1 100%;" @click="hide('err')">
        CLOSE
      </button>
    </div>
  </div>
  </modal>
  <!-- 入力エラーダイアログここまで -->
  <contact_approved></contact_approved>
</div>
</template>

<script>
import ContactApproved from '../components/Contact_approved.vue'
import contact from '@/const/contact'
import axios from 'axios'

export default {
  name: 'contact',
  layout: 'app',
  components: {
    'contact_approved': ContactApproved
  },
  data () {
    return {
      contactTitle: {
        subject: '件名',
        company: '会社名 / 学校名 / 団体名',
        name: 'お名前',
        nameKana: 'オナマエ',
        phone: '電話番号',
        email: 'メールアドレス',
        message: 'お問い合わせ内容'
      },
      subject: null,
      companyName: null,
      firstName: null,
      lastName: null,
      firstNameKana: null,
      lastNameKana: null,
      phone: null,
      email: null,
      message: null,
      errors: []
    }
  },
  methods: {
    formSubmit: function (e) {
      e.preventDefault()

      if (this.checkForm()) {
        this.show('ack')
      } else {
        this.show('err')
      }
    },
    sendSlack: function () {
      let text = 'コーポレートにお問い合わせがありました\n'
      text += contact.GSS_URL + '\n'
      text += '```\n'
      text += '件名: ' + this.subject + '\n'
      text += '会社名: ' + this.companyName + '\n'
      text += '名前: ' + this.firstName + this.lastName + '\n'
      text += '電話番号: ' + this.phone + '\n'
      text += 'メールアドレス: ' + this.email + '\n'
      text += 'お問い合わせ内容: ' + this.message + '\n'
      text += '```\n'

      let params = new URLSearchParams()
      params.append('token', contact.TOKEN)
      params.append('channel', contact.CHANNEL)
      params.append('text', text)
      params.append('as_user', 'true')

      axios.post('https://slack.com/api/chat.postMessage', params).then(function (res) {
      })
    },
    sendRequest: function () {
      this.sendSlack()

      let params = new FormData()

      let subject = this.subject
      if (subject === 'その他') {
        params.append('entry.2051981835.other_option_response', 'その他')
        subject = '__other_option__'
      }

      params.append(contact.FORM['subject'], subject)
      params.append(contact.FORM['phone'], this.phone.replaceAll('-', ''))
      params.append(contact.FORM['companyName'], this.companyName)
      params.append(contact.FORM['firstName'], this.firstName)
      params.append(contact.FORM['lastName'], this.lastName)
      params.append(contact.FORM['firstNameKana'], this.firstNameKana)
      params.append(contact.FORM['lastNameKana'], this.lastNameKana)
      params.append(contact.FORM['email'], this.email)
      params.append(contact.FORM['message'], this.message)
      axios.post(contact.POST_URL, params).then(function (res) {
        console.log('ok')
      })
    },
    checkForm: function () {
      this.errors = []
      if (!this.subject) {
        this.errors.push('件名 が空欄です')
      }
      if (!this.companyName) {
        this.errors.push('会社名 が空欄です')
      }
      if (!this.firstName) {
        this.errors.push('姓 が空欄です')
      }
      if (!this.lastName) {
        this.errors.push('名 が空欄です')
      }
      if (!this.firstNameKana) {
        this.errors.push('セイ が空欄です')
      }
      if (!this.lastNameKana) {
        this.errors.push('メイ が空欄です')
      }
      if (!this.phone) {
        this.errors.push('電話番号 が空欄です')
      } else {
        const phone = this.phone.replaceAll('-', '')
        if (isNaN(phone)) {
          this.errors.push('電話番号 が不正です')
        }
      }
      if (!this.email) {
        this.errors.push('メールアドレス が空欄です')
      }
      if (!this.message) {
        this.errors.push('お問い合わせ内容 が空欄です')
      }

      if (this.errors.length > 0) {
        return false
      }
      return true
    },
    show (status) {
      this.$modal.show(status)
    },
    hide (status) {
      this.$modal.hide(status)
    },
    replaceView () {
      let f = document.querySelector('#form')
      f.style.display = 'none'

      let fThanks = document.querySelector('#f-thanks')
      fThanks.style.display = 'block'
    },
    toTop: function () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style scoped>
    .v--modal-overlay {
      z-index: 9999 !important;
    }
  body {
    /*overflow: hidden;*/
  }
  a{
    text-decoration: none;
    font-size: 0.9em;
  }
  ul,li{
    list-style: none;
  }
  .contact_content{
    max-width: 820px;
    width: 90%;
    margin:0 auto;
    padding: 30px 0;
  }
  .contactImg{
    width: 100%;
    margin-top: 65px;
  }
  .contactSPImg{
    display: none;
  }
  .contact_content h2{
    background: url(../assets/svg/about.svg) no-repeat left center;
    background-size: 70px;
    padding: 20px 0 20px 80px;
  }
  .contact_box{
    margin: 40px 0;
  }
  select {
    background-color: white;
    border: 2px solid #b5b5b5;
    border-radius: 4px;
    display: inline-block;
    font: inherit;
    line-height: 1.5em;
    padding: 1.0em 3.5em 1.0em 1em;
    margin: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 100%;
    margin-bottom: 16px;
  }
  select.minimal {
    width: 40%;
    min-width: 250px;
    background: url("../assets/img/arrow.svg") no-repeat;
    background-size: 20px 20px;
    background-position: right 10px center;
  }
  .contact_box input[type='text'], .contact_box input[type='email'],.contact_box input[type='tel'] {
    font-size: 1.2em;
    box-sizing: border-box;
    width: 100%;
    transition: 0.3s;
    letter-spacing: 1px;
    color: #aaaaaa;
    border: none;
    border-bottom: 2px solid #b5b5b5;
    background: transparent;
    padding: 8px 0;
    margin-bottom: 16px;
  }
  .contact_color input[type='text']:focus, .contact_color input[type='email']:focus,.contact_color input[type='tel']:focus {
    border-bottom: 2px solid #1f30aa;
    outline: none;
  }
  .contact_color_box textarea[type='text'] {
    /*font: 15px/24px sans-serif;*/
    font-size: 1.2em;
    box-sizing: border-box;
    width: 100%;
    padding: 12px;
    transition: 0.3s;
    letter-spacing: 1px;
    color: #aaaaaa;
    border: 2px solid #b5b5b5;
    background: transparent;
    margin-bottom: 16px;
    height: 200px;
  }
  ul.footer_list li a{
    color: #ffffff;
  }
  .contact_color_box2 textarea[type='text']:focus {
    border: 2px solid #1f30aa;
    outline: none;
  }
  p.contact_title{
    font-size: 1.2em;
    color: #1f30aa;
    padding: 32px 0 16px 0;
    width: 100%;
    clear: both;
  }
  ul.footer_company a.footer_button{
    color: #1f30aa;
    font-size: 1.2em;
  }

  .contact_short{
    width: 48%;
    float: left;
    margin-right: 2%;
  }
  .vue-dialog-button {
    position: absolute;
    bottom: 0;
  }
  .dialog-content ul li{
    padding: 10px 40px;
    font-weight: bold;
  }
  .dialog-content .dialog-alert {
    text-align: center;
  }
  .dialog-content .dialog-alert-text{
    font-weight: 900;
    color: #1f30aa;
    font-size: 20px;
    margin-bottom: 0;
  }
    @media screen and (max-width:400px)
    {
      .dialog-content .dialog-alert-text{
        margin-top: 12px;
        font-size: 18px;
        margin-bottom: 0;
      }
    }
  .dialog-content dl{
    padding: 10px 40px;
    overflow-y: scroll;
    height: 430px;
  }
  .dialog-content dl dd{
    padding: 5px 0;
    font-weight: bold;
    word-break: break-all;
  }
  .contact_page_btn{
    color: #fff!important;
    background-color: #1f30aa!important;
    display: inline-block;
    width: 100%;
    height: 60px;
    text-align: center;
    text-decoration: none;
    line-height: 60px;
    outline: none;
    font-size: 18px;
  }
  .contact_page_btn::before,
  .contact_page_btn::after{
    position: absolute;
    z-index: -1;
    display: block;
    content: '';
  }
  .contact_page_btn,
  .contact_page_btn::before,
  .contact_page_btn::after{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all .3s;
    transition: all .3s;
  }
  .contact_page_btn:hover{
    background-color: #fff;
    border-color: #1f30aa;
    color: #1f30aa;
  }
  /*@media screen and (max-width:500px) {*/
  /*  .v--modal {*/
  /*    margin: 130px auto 0 auto;*/
  /*    height: 120vw !important;*/
  /*    width: 90% !important;*/
  /*    left: 0 !important;*/
  /*    top: 18% !important;*/
  /*  }*/
  /*}*/
  /*@media screen and (max-width:499px) {*/
  /*  .v--modal {*/
  /*    width: 90% !important;*/
  /*    left: 0 !important;*/
  /*    margin: 0 auto;*/
  /*    height: 140vw !important;*/
  /*    top: 18% !important;*/
  /*  }*/
  /*}*/
  /*@media screen and (max-width:768px) {*/
  /*  .v--modal {*/
  /*    width: 90% !important;*/
  /*    left: 0 !important;*/
  /*    margin: 22% auto 0 auto;*/
  /*    height: 140vw !important;*/
  /*    top: 18% !important;*/
  /*  }*/
  /*  .dialog-content dl{*/
  /*    height: 200px;*/
  /*  }*/
  /*  select.minimal{*/
  /*    width: 100%;*/
  /*  }*/
  /*  .contact_content{*/
  /*    width: 90%;*/
  /*    margin: 0 auto;*/
  /*  }*/
  /*  .contactSPImg{*/
  /*    display: block;*/
  /*    width: 100%;*/
  /*  }*/
  /*  .contactImg{*/
  /*    display: none;*/
  /*  }*/
  /*  .contact_box{*/
  /*    margin: 0;*/
  /*  }*/
  /*  p.contact_title{*/
  /*    font-size: 1.0em;*/
  /*  }*/
  /*  .contact_box input[type='text'] ,*/
  /*  .contact_color_box textarea[type='text']{*/
  /*    font-size: 1.0em;*/
  /*  }*/
  /*  .contact_short{*/
  /*    width: 100%;*/
  /*    float: none;*/
  /*  }*/
  /*  .contact_page_btn{*/
  /*    margin-top: 0;*/
  /*  }*/
  /*  .contact_page_btn-l{*/
  /*  border-right:1px solid #ffffff!important;*/
  /*}*/
  /*  .dialog-content dl{*/
  /*    height: 100px;*/
  /*  }*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/pages/contact.vue